/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-24 18:04:06
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-28 17:39:18
 * @FilePath: \mpc-monorepo\apps\mpc-external\src\containers\OutWorkbench\ProjectDetail\Show\Detail\Bottom\SupplierSubmissionKol\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useRef, useState } from 'react'
import { Space, Button, Tag, Form, Input, Message, Divider, Alert } from '@bedrock/components'
// @ts-ignore
import PropTypes from 'prop-types'
import { useMemoizedFn } from 'ahooks'
import { TabContent } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/components';
import classNames from 'classnames/bind'
import styles from './index.less'
import { ProCard } from '@bedrock/eed-react';
import { SupplierKOLTable } from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation';
import RequirementContent from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/RequirementContent';
import { FormItemRow } from '@mpc/common/src/components/SForm/createFormItemRow';
import { currencyOptions } from '@mpc/common/src/utils/number';
import { BatchEdit, Check, CheckCircle, Close, Download, Save, SignOut } from '@bedrock/icons-react';
import { useImportFileModal } from "@mpc/common/src/features/importFileModal";
import ExportFilePollingBtn from '@mpc/common/src/features/ExportFilePollingBtn';
import { outsourceDemandCommonTemporarySaveDemand, outsourceDemandCommonTemporarySelectDemand, outsourceDemandSourceDemandPass, outsourceDemandSourceDemandReject } from '@/services/api';
import dayjs from 'dayjs';
import ReasonMdodal from '@mpc/common/src/components/ReasonModal';

const cx = classNames.bind(styles)

function SupplierSubmissionKOL(props: { tabKey: string; intl?: any; detail?: any; loadDetail?: any }) {
  const { tabKey, intl, detail, loadDetail } = props;
  const scrollbarRef = useRef<any>(null);
  const [form] = Form.useForm();
  const { openImportFileModal, closeImportFileModal } = useImportFileModal({});
  const importType = `demand_source_supplier_live_kol${detail?.id}`;

  const [saveDraftTime, setSaveDraftTime] = useState<any>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    form.setFieldsValue({
      ...detail,
      demand_source_detail_vo: {
        ...detail?.demand_source_detail_vo,
        // 默认货币类型消息
        $currency: detail?.demand_source_detail_vo?.$currency || 'rmb',
      },
    });
    queryDraft();
  }, []);

  const queryDraft = useMemoizedFn(() => {
    return outsourceDemandCommonTemporarySelectDemand({
      demand_id: detail?.id,
    }).then((res: any) => {
      const data = JSON.parse(res?.data || '{}');
      form.setFieldsValue({
        ...detail,
        demand_source_detail_vo: data?.demand_source_detail_vo || {},
      });
      setSaveDraftTime(data?.$draftTime);
    }).catch((error: any) => {
      console.log('queryDraftError', error);
    });
  });

  // 暂存
  const handleDraft = useMemoizedFn(() => {
    const values = form.getFieldsValue();
    const draftTime = new Date().getTime();
    const dataString = JSON.stringify({
      $draftTime: draftTime,
      demand_source_detail_vo: values.demand_source_detail_vo,
    });
    setLoading(true);
    return outsourceDemandCommonTemporarySaveDemand({
      demand_id: detail?.id,
      content: dataString,
    }).then((res: any) => {
      Message.success('操作成功');
      setSaveDraftTime(draftTime);
    }).finally(() => {
      setLoading(false);
    });
  });

  const handleSubmit = useMemoizedFn(() => {
    form.validateFields().then((values) => {
      console.log('values', values);
      //请至少提报1个达人
      if (values.demand_source_detail_vo?.demand_source_supplier_kol_vos?.length === 0) {
        Message.warn('请至少提报1个达人');
        return;
      }
      setLoading(true);
      return outsourceDemandSourceDemandPass({
        id: detail?.id,
        state: detail?.state,
        pass: true,
        biz_cmd: {
          type: 3,
          demand_source_supplier_sign_kol_create_cmd_list: values.demand_source_detail_vo?.demand_source_supplier_kol_vos.map((n: any) => {
            // 写入货币类型
            return {
              ...n,
              quote_price_currency: values.demand_source_detail_vo?.$currency,
              demand_source_id: detail?.id,
              remark: n.remark_dto?.text,
              blob_id_list: n.remark_dto?.files?.map((file: any) => file.blob?.id || file?.id || file?.blob_id) || []
            };
          }),
        },
      } as any).then((res: any) => {
        Message.success('操作成功');
        loadDetail?.();
      }).finally(() => {
        setLoading(false);
      });
    });
  });



  const handleBatchSubmission = async () => {
    const supplier_kol_cmd_list = form.getFieldValue(['demand_source_detail_vo', 'demand_source_supplier_kol_vos'])
    openImportFileModal({
      importType,
      importIsMemory: false,
      importTitle: '批量提报达人',
      showSuccessToast: false,
      customDownloadRender: () => (
        <div>
          <Space size='xSmall' split={<Divider />}>
            <ExportFilePollingBtn
              exportKey='BATCH_REPORTING_EXPERT'
              params={{
                demand_source_id: detail?.id,
                supplier_kol_cmd_list,
              }}
              buttonProps={{
                icon: <SignOut />,
                type: 'link',
              }}
              buttonText='导出当前数据'
            />
            {/* <Button
              icon={<Download />}
              type='link'
              onClick={() => {
                window.open(`/api/outsource/v2/java_proxy/common/data/${importType}/import-template`)
              }}
            >
              下载空模板
            </Button> */}
          </Space>
          <div className="download-span fs-12 m-l-4">
            (上传前请先下载Excel模板并按照模板格式编辑文件，或先导出当前表格编辑后再导入；模版内多 Sheet 请勿删除)
          </div>
        </div>
      ),
      uploadFinishedCallback: (res) => {
        // 有错误时，不进行数据更新
        if (res?.data?.fail_count > 0) return;
        if (res.code === 1 && res.data?.data?.length) {
          closeImportFileModal();
          const list = res?.data?.data?.map(v => ({
            ...v,
            id: Math.random()
          }));
          form.setFieldValue(['demand_source_detail_vo', 'demand_source_supplier_kol_vos'], list)
          Message.success(`导入覆盖成功 ${list.length} 个达人`)
        }
      },
    })
  }

  const handleRejectOrder = async () => {
    ReasonMdodal.show({
      title: '拒单',
      okText: '确定拒单',
      okButtonProps: { danger: true },
      reasonLabel: '拒单原因',
      headerPlace: <Alert
        showIcon
        type='warning'
        message="确定拒绝此单吗?"
        description="如确定拒绝此订单，需填写拒单原因以便我方知晓原因。"
        className="m-b-20"
      />,
      onOk: async (v: { reason?: string }) => {
        try {
          await outsourceDemandSourceDemandPass({
            id: detail?.id,
            state: detail?.state,
            pass: true,
            biz_cmd: {
              type: 3,
              reject_by_supplier: true,
              reason: v?.reason,
          } 
          })
          Message.success('操作成功');
          loadDetail?.();
        } catch (error) {
          console.log('error', error)
        }
      },
    })
  }

  const bottom = useMemoizedFn(() => {
    return (
      <div className="w-full flex justify-between items-center pt-5">
        <div>
          <Button loading={loading} type="checked" icon={<BatchEdit />} onClick={handleBatchSubmission}>
            批量提报达人
          </Button>
        </div>
        <div className="flex justify-start items-center gap-3">
          {saveDraftTime && <div className="flex justify-start items-center gap-1">
            <CheckCircle className="text-color-3 text-base" />
            <div className="text-sm font-normal text-color-3">{dayjs(saveDraftTime).format('YYYY-MM-DD HH:mm:ss')} 已保存</div>
          </div>}
          <Button loading={loading} danger icon={<Close />} onClick={handleRejectOrder}>
            拒单
          </Button>
          <Button loading={loading} type="checked" icon={<Save />} onClick={handleDraft}>
            暂存
          </Button>
          <Button loading={loading} type="primary" icon={<Check />} onClick={handleSubmit}>
            提交
          </Button>
        </div>
      </div>
    )
  })
  // @ts-ignore TabContent supports children but type definition doesn't
  return <TabContent
    className={cx('supplier-submission-kol-bottom-wrapper')}
    tabKey={tabKey}
    bottom={bottom()}
    canScroll={true}
    resizeAble={true}
    ref={scrollbarRef as any}
  >
    <Form form={form}>
      <div className={cx('supplier-submission-kol-content')}>
        {detail?.demand_suppliers?.[0]?.re_quotation_flag && <Alert
          message='报价被退回，请在截止时间内重新报价'
          description={`退回原因：${detail?.demand_suppliers?.[0]?.re_quotation_reason || '--'}`}
          type='warning'
          showIcon
          style={{ marginBottom: 20 }}
        />}
        <div className="flex justify-between items-center w-full self-stretch shrink-0 mb-4">
          <div className="flex justify-start items-start gap-2 h-[22px]">
            <div className="flex justify-start items-center gap-0.5">
              <div className="text-base font-normal text-color-3">提报轮次</div>
              <div className="text-base font-normal text-color-3">:</div>
            </div>
            <div className="flex justify-start items-center gap-1.5 self-stretch">
              <Tag size="xSmall" color="brand" text={`${detail?.turns_number} 轮`} />
            </div>
          </div>
          <div className="flex justify-start items-start gap-2 h-[22px]">
            <div className="flex justify-start items-center gap-0.5">
              <div className="text-base font-normal text-color-3">截止时间</div>
              <div className="text-base font-normal text-color-3">:</div>
            </div>
            <div className={cx("text-base font-[600]","warning-text")}>{detail?.quote_deadline}</div>
          </div>
        </div>
        <div>
            <RequirementContent 
              view detail={detail}
              l3_category_id={detail?.l3_category_id}
              tabsModel={true}
              proCardProps={{
                noPadding: false,
                level: 1,
                expandable: true,
              }}
              bottomSlot={
                <div className='m-t-16'>
                  <FormItemRow
                    renderType="descriptions"
                    formItemMap={{} as any}
                    renderData={{
                      detailData: detail,
                    }}
                    itemCols={[{
                      formItemKey: 'demand_source_detail_vo.$currency',
                      label: '币种',
                      componentClass: 'select',
                      required: true,
                      elementProps: {
                        options: currencyOptions,
                      },
                    }]}
                  />
                </div>
              }
            />
            <div className='m-t-16'>
              <FormItemRow
                renderType="row"
                formItemMap={{} as any}
                renderData={{
                  detailData: detail,
                }}
                itemCols={[{
                  formItemKey: 'demand_source_detail_vo.demand_source_supplier_kol_vos',
                  label: '提报指定达人',
                  showLabel: false,
                  col: 24,
                  className: 'w-full',
                  watchChildFormValidate: true,
                  validateTrigger: false,
                  render: () => {
                    return <SupplierKOLTable detailData={detail} handleBatchSubmission={handleBatchSubmission}/>
                  },
                }]}
              />
            </div>
        </div>
      </div>
    </Form>
  </TabContent>
}

class Index extends React.Component<{ tabKey: string }, any> {
  public static contextTypes = {
    intl: PropTypes.object,
    prefixCls: PropTypes.string,
    menuKey: PropTypes.string,
    detail: PropTypes.any,
    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
  };

  public render() {
    const { intl, detail, loadDetail } = this.context as any;
    const { tabKey } = this.props;

    return <SupplierSubmissionKOL
      tabKey={tabKey}
      intl={intl}
      detail={detail}
      loadDetail={loadDetail}
    />;
  }
}

export default Index;
